import { PUBLIC_ROUTE } from "../../../../route.constants";
import { smoothScroll } from "@utils/helpers/smoothScroll";
import { setupLoanRoute } from "@utils/helpers/navigators";
import { VERIFY_ROUTES } from "../../../../constants/commonConstants";

const thankYouRoute = PUBLIC_ROUTE.THANK_YOU;

const shouldRouteBeActive = (verifyState, pathname) => {
  const { nextScreen } = verifyState;
  
  return pathname !== thankYouRoute && nextScreen === VERIFY_ROUTES.THANK_YOU;
}

const navigateTo = (navigate) => {
  navigate(thankYouRoute + window.location.search);
  smoothScroll();
};

export const verifyThankYouNavigation = setupLoanRoute({shouldRouteBeActive, navigateTo});

